import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm text-foreground-500">
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-2">
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900">{item.label}</span>
          )}
          {idx < items.length - 1 && (
            <span className="flex h-4 w-4 items-center justify-center text-foreground-300">
              <i className="ri-arrow-right-s-line text-sm"></i>
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}